function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M242.62,317.61c-31.11,15.1-48.23,40.58-41.75,50.77s40.17,5.7,65.22-13.88c27.84-21.77,32-28.08,45.54-42.6,6.37-6.85,10.28-19.93-5.93-16.27C288.88,299.42,270.47,304.08,242.62,317.61Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M398.41,43.34A255.93,255.93,0,0,0,4.94,305.67,255.91,255.91,0,0,0,305.68,507.05q5.43-1.07,10.76-2.38c2.2-.58,3.73-.92,5.64-1.43a255.93,255.93,0,0,0,185-296.93A254.23,254.23,0,0,0,398.41,43.34ZM281.86,388.69a19.68,19.68,0,0,0-7.43,22.87c10.72,30,16,47.65,18.67,57.78C177.71,489.44,66.42,413.52,43.57,298,24.25,200.43,74.11,104.91,159,62.35c2.9,10.29,38.36,61.44,80,89.62,49,33.22,87.18,49.67,128.15,54l1.08.09c12.95.64,29.13,9.34,34.09,26.91C406.38,247.39,409.72,301.28,281.86,388.69Z"
});

var SvgOnNosSiva3 = function SvgOnNosSiva3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnNosSiva3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ON_nos_siva_3.254976b4.svg";
export { ForwardRef as ReactComponent };